import { render, staticRenderFns } from "./InstructionsAdd.vue?vue&type=template&id=858031fa&"
import script from "./InstructionsAdd.vue?vue&type=script&lang=js&"
export * from "./InstructionsAdd.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsAdd.vue?vue&type=style&index=0&id=858031fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports